module.exports = __webpack_public_path__ + "img/handback.d777ec82.png";